import type { MeetingListParams } from './types';

export const meetingsQueryKeys = {
  all: ['meetings'] as const,
  lists: () => [...meetingsQueryKeys.all, 'list'] as const,
  list: (params?: MeetingListParams) =>
    [...meetingsQueryKeys.lists(), params] as const,
  details: () => [...meetingsQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...meetingsQueryKeys.details(), id] as const
};
